module.exports = __webpack_public_path__ + "static/media/01.91bd47ee.jpg";